import type { FilterRuleModel } from '@/shared/generated'

import React, { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAssortmentListQuery } from '@/entities/assortment'

import { Operators } from '@/shared/components/query-builder'
import { Badge } from '@/shared/components/ui/badge'
import { Spinner } from '@/shared/components/ui/spinner'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { formatValue } from '@/shared/lib/format'

export function Prediction({
	filters: _filters,
}: {
	filters: FilterRuleModel[]
}) {
	const { t } = useTranslation()
	const skus = useWatch({ name: 'skus' })
	const filters = useMemo((): FilterRuleModel[] => {
		if (_filters?.length > 0) {
			return _filters
		}
		if (skus?.filter(Boolean)?.length > 0) {
			return [
				{
					name: 'sku',
					operation: Operators.IN,
					value: skus?.filter(Boolean),
				},
			]
		}

		return []
	}, [_filters, skus])
	const assortmentQuery = useAssortmentListQuery(
		{
			limit: 1,
			filters,
		},
		{
			refetchOnMount: 'always',
		}
	)
	const skusNumber = assortmentQuery.data?.total_skus
	const isLoading = assortmentQuery.isLoading

	return isLoading ? (
		<Badge className='font-mono'>
			<Spinner data-icon='inline-start' />
			{t('loading')}
		</Badge>
	) : (
		<Tooltip>
			<TooltipTrigger asChild>
				<Badge className='font-mono'>
					{`${skusNumber ? `${formatValue(skusNumber)}` : '0'}`}
				</Badge>
			</TooltipTrigger>
			<TooltipContent>
				{t('import.prediction.tooltip', {
					defaultValue: 'The number of products that will be updated',
				})}
			</TooltipContent>
		</Tooltip>
	)
}
